import { formatChf } from '@agentselly/ui';

/**
 * Preis als CHF 1'250'000. Dünne Hülle um den geteilten Formatter aus
 * `@agentselly/ui`, damit es im Monorepo nur eine Intl-Implementierung für den
 * Schweizer Standard gibt (AGE-162).
 *
 * Eigenheiten gegenüber dem geteilten Formatter bleiben erhalten: `0` und
 * ungültige Werte gelten als "kein Preis" und ergeben `defaultValue`, und
 * Rappen werden angezeigt, wenn sie im Wert stecken.
 */
export function formatPrice(
  price: string | number | undefined,
  defaultValue: string = '',
): string {
  const numPrice = Number(price);

  if (price === null || price === undefined || price === '') {
    return defaultValue;
  }

  if (!Number.isFinite(numPrice) || numPrice === 0) {
    return defaultValue;
  }

  return formatChf(numPrice, { maximumFractionDigits: 2 });
}
